import { Checkbox, HStack, Link, Text } from "@chakra-ui/react"
import { CheckIcon, IconName } from "@pathwright/pathicons"
import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import { MouseEvent } from "react"
import { Change } from "./types"

export type CardItemProps = {
  title: string
  itemUrl?: string | null
  statusUrl?: string | null
  onClick?: (event: MouseEvent) => void
  status?: string
  icon?: IconName
  change?: Change
  leftIcon?: IconName
  onCheck?: (checked: boolean) => void
  isChecked?: boolean
  isChild?: boolean
  isDisabled?: boolean
}

const CardItem = (props: CardItemProps) => {
  const {
    title,
    itemUrl,
    statusUrl,
    status,
    icon,
    leftIcon,
    onClick,
    onCheck,
    isChild,
    isChecked,
    isDisabled
  } = props

  const renderItemContent = () => (
    <>
      <HStack
        justify="space-between"
        w="full"
        gap={0}
        pl={isChild ? 6 : 0}
        _hover={{
          ".PathPublishCard__item-title": {
            textDecoration: onClick || itemUrl ? "underline" : ""
          }
        }}
      >
        <HStack gap={1} overflowX="auto">
          {leftIcon && (
            <Pathicon
              icon={leftIcon! as IconName}
              size="1.6em"
              color="gray.400"
              style={{
                marginRight: "2px"
              }}
              className="PathPublishCard__item-left-icon"
            />
          )}
          <Text
            m={0}
            mr={2}
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            className="PathPublishCard__item-title"
          >
            {title}
          </Text>
        </HStack>
        {status ? (
          <Text
            className="PathPublishCard__item-status"
            as={"span"}
            fontStyle="italic"
            m={0}
            color="gray.500"
            whiteSpace="nowrap"
            textDecoration={statusUrl ? "underline" : "none"}
          >
            {status}
          </Text>
        ) : null}
        {icon && (
          <Pathicon icon={icon! as IconName} size="1.6em" color="gray.600" />
        )}
      </HStack>
    </>
  )

  const renderItem = () => {
    return (
      <HStack
        className="PathPublishCard__item"
        py={1}
        px={4}
        bg={"white"}
        w="full"
        boxShadow="sm"
      >
        {onCheck ? (
          <Checkbox
            isChecked={isChecked}
            isDisabled={isDisabled}
            aria-checked={isChecked}
            onChange={(e) => {
              onCheck(e.target.checked)
            }}
            icon={<CheckIcon />}
            iconColor={"primaryBrandColor.main"}
            colorScheme={"blue"}
            role="checkbox"
            outline="none"
            sx={{
              ".chakra-checkbox__control:not([data-checked]):not([data-disabled])": {
                backgroundColor: "white",
                borderColor: "rgba(68, 68, 68, 0.9)",
                borderWidth: "1px"
              },
              ".chakra-checkbox__control[data-disabled]": {
                backgroundColor: "var(--chakra-colors-blackAlpha-200)",
                borderColor: "var(--chakra-colors-blackAlpha-300)",
              },
              ".chakra-checkbox__control:not([data-checked]) svg": {
                opacity: 0
              }
            }}
          />
        ) : null}
        {itemUrl || onClick ? (
          <Link href={itemUrl!} onClick={onClick} w="full">
            {renderItemContent()}
          </Link>
        ) : (
          renderItemContent()
        )}
      </HStack>
    )
  }

  return renderItem()
}

export default CardItem
